import customAxios from ".";
import { logoutAllDevices } from "../utils";

const axiosInstance = customAxios;
const FetchService = {
  postCall({ url, body, ...rest }) {
    const {
      headers: recievedHeaders,
      loaderConfig,
      options = {},
      responseType
    } = rest;
    let headers = { ...recievedHeaders };
    const conf = { headers, loaderConfig, responseType };

    // Handle FormData properly - don't spread it
    const requestBody = body instanceof FormData ? body : { ...body };

    return axiosInstance.post(url, requestBody, conf).catch(err => {
      logoutAllDevices(err);
    });
  },
  getCall({ url, query, ...rest }) {
    const { headers, loaderConfig, data } = rest;
    const conf = { params: query, headers, loaderConfig, data };
    return axiosInstance.get(url, conf).catch(err => {
      logoutAllDevices(err);
    });
  }
};

export default FetchService;
